import { render } from "./dpp-button.vue?vue&type=template&id=04c39541"
import script from "./dpp-button.js?vue&type=script&lang=js"
export * from "./dpp-button.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__